import React from 'react';
import { BrowserRouter, Routes as RouterRoutes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import ErrorBoundary from './components/ErrorBoundary';

// All pages using React.lazy() for consistent code splitting
const HomePage = React.lazy(() => import('./pages/homepage'));
const AdminDashboard = React.lazy(() => import('./pages/admin-dashboard'));
const SolutionFinderTool = React.lazy(() => import('./pages/solution-finder-tool'));
const SolutionsCategories = React.lazy(() => import('./pages/solutions-categories'));
const ResourceLibrary = React.lazy(() => import('./pages/resource-library'));
const ConsultationGateway = React.lazy(() => import('./pages/consultation-gateway'));
const WikiPage = React.lazy(() => import('./pages/wiki-page'));
const AuthorityCenter = React.lazy(() => import('./pages/authority-center'));
const KnowledgeHub = React.lazy(() => import('./pages/knowledge-hub'));
const NotFound = React.lazy(() => import('./pages/NotFound'));
const UserAuthenticationPortal = React.lazy(() => import('./pages/user-authentication-portal'));
const UserDashboard = React.lazy(() => import('./pages/user-dashboard'));
const SignInPage = React.lazy(() => import('./pages/sign-in'));
const SignUpPage = React.lazy(() => import('./pages/sign-up'));
const SavedArticlesPage = React.lazy(() => import('./pages/saved-articles'));
const InteractiveBusinessScorecardPage = React.lazy(() => import('./pages/interactive-business-scorecard'));
const PublicQuestions = React.lazy(() => import('./pages/public-questions/index'));
const QuestionDetail = React.lazy(() => import('./pages/public-questions/QuestionDetail'));

// Import App for layout
import App from './App';

export default function Routes() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <React.Suspense 
          fallback={
            <div className="min-h-screen flex items-center justify-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            </div>
          }
        >
          <RouterRoutes>
            <Route path="/" element={<App />}>
              <Route index element={<HomePage />} />
              <Route path="admin-dashboard" element={<AdminDashboard />} />
              <Route path="solution-finder-tool" element={<SolutionFinderTool />} />
              <Route path="solutions-categories" element={<SolutionsCategories />} />
              <Route path="resource-library" element={<ResourceLibrary />} />
              <Route path="consultation-gateway" element={<ConsultationGateway />} />
              <Route path="wiki-page" element={<WikiPage />} />
              <Route path="authority-center" element={<AuthorityCenter />} />
              <Route path="knowledge-hub" element={<KnowledgeHub />} />
              <Route path="user-authentication-portal" element={<UserAuthenticationPortal />} />
              <Route path="user-dashboard" element={<UserDashboard />} />
              <Route path="sign-in" element={<SignInPage />} />
              <Route path="sign-up" element={<SignUpPage />} />
              <Route path="saved-articles" element={<SavedArticlesPage />} />
              <Route path="interactive-business-scorecard" element={<InteractiveBusinessScorecardPage />} />
              <Route path="questions" element={<PublicQuestions />} />
              <Route path="questions/:slug" element={<QuestionDetail />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </RouterRoutes>
        </React.Suspense>
      </ErrorBoundary>
    </BrowserRouter>
  );
}